/**
 * @overview 问卷模版新增编辑页面
 * @author Ariel
 * @date 2020-3-18
 */
import React from 'react';
import {connect} from 'dva';
import SurveyTemplateQuestionDetail from '../surveyTemplateQuestionDetail/surveyTemplateQuestionDetail'
import {framework_tool, component_tool, utils_tool} from '../../../../tool'

let {WizContainer, modelUtils, WizAvatarUpload, ossFileUtils} = framework_tool;
let {WizForm, WizButton, WizRow, WizCol, WizSpin, WizCustomSteps, WizNotice, Wizmessage} = component_tool;
let {Session} = utils_tool;

const steps = [
  {
    title: '模版信息',
    content: 'First-content',
  },
  {
    title: '问卷模版设计',
    content: 'Second-content',
  }
];

const getParamRecord = (history) => {
  let record = {};
  if (history.location) {
    if (history.location.pathname === '/biz/surveyTemplate/surveyTemplateDetailUpd') {
      if (history.location.record) {
        record = history.location.record;
        Session.set('surveyTemplateDetailUpd', record)
      } else {
        record = Session.get('surveyTemplateDetailUpd') || {};
      }
    }
    if (history.location.pathname === '/biz/surveyTemplate/surveyTemplateDetailAdd') {
      if (history.location.record) {
        record = history.location.record;
        Session.set('surveyTemplateDetailAdd', record)
      } else {
        record = Session.get('surveyTemplateDetailAdd') || {};
      }
    }
  }
  if (record && (record.status == null || record.status == undefined )) {
    record.status = 1
  }
  return record
}

class SurveyTemplateDetail extends WizContainer {

  componentName = 'surveyTemplateDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let record = getParamRecord(history)
    const {id} = record
    this.initialValue = record
    this.state = {
      current: 0,
      surveyTemplateId:id
  }
    this.nextStepState = false;
  }

  _componentDidMount() {
  }

  propsAndStateOnChange = {
    addSurveyTemplate: this._stepOne.bind(this),
  }

  _stepOne(nextProps, nextState) {
    if (nextProps.addSurveyTemplate.code == 1) {
      this.initialValue = nextProps.addSurveyTemplate.data
      WizNotice.success('保存成功');
      if (this.nextStepState) {
        this.nextStepState = false;
        nextState.current = this.state.current + 1;
        nextState.surveyTemplateId = nextProps.addSurveyTemplate.data.id
      } else {
        this.jumpPage('replace', '/biz/surveyTemplate');
      }
    } else {
      this.nextStepState = false;
      WizNotice.error('保存失败：' + nextProps.addSurveyTemplate.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    /**
     * 图片参数处理
     */
    let questionImg = fitterValues['questionImg']
    if (questionImg && questionImg.length) {
      fitterValues['img'] = questionImg[0]['fileId']
      delete fitterValues['questionImg']
    }
    return fitterValues;
  }

  /**保存问卷信息 */
  _saveSurveyTemplate(values) {
    let apiPath = 'surveyTemplate/add';
    if (this.state.surveyTemplateId) {
      apiPath = 'surveyTemplate/update'
    }
    let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: 'addSurveyTemplate',
        apiParams: {
          ...fitterValues,
        }
      }
    });

  }

  /**下一步 */
  nextStep() {
    this.nextStepState = true;
  }

  /**表单底部按钮 */
  formFooter = () => {
    return (
      <WizRow className="form-btns row-item">
        <WizCol span={24}>
          <WizButton title='保存并进入下一步' type='primary' htmlType='submit'
                     onClick={e => this.nextStep()}>保存并进入下一步</WizButton>
          <WizButton title='保存并返回' htmlType='submit'>保存并返回</WizButton>
          <WizButton title='重置' type='reset' onClick={e => this._onReset()}>重置</WizButton>
        </WizCol>
      </WizRow>
    )
  }

  _onReset() {
    this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
  }

  /**根据步骤展示内容 */
  stepView(formProps) {
    if (this.state.current == 0) {
      return <WizForm className={'form-inline'} {...formProps} />
    } else if (this.state.current == 1) {
      const {history} = this.props;
      let type = 'create';
      if (history.location && history.location.pathname === '/biz/surveyTemplate/surveyTemplateDetailUpd') {
        type = 'update'
      }
      return <SurveyTemplateQuestionDetail
        surveyTemplateId={this.state.surveyTemplateId}
        type={type}
        backFunc={() => this.jumpPage('replace', '/biz/surveyTemplate')}
        prevFunc={() => this.setState({current: this.state.current - 1})}
      />
    } else {
      return null;
    }
  }

  _render() {
    const {surveyTemplateLoading} = this.props;

    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: this.initialValue.id
        }
      },
      {
        title: '模版名称',
        name: 'title',
        formItem: {
          maxLength: 50,
          placeholder: '模版名称最多输入50个字',
          rules: [
            {
              required: true,
              message: '请输入模版名称',
            },
            {
              pattern: /^[^\s]*$/,
              message: '模版名称录入信息不能包含空格'
            }
          ],
          initialValue: this.initialValue.title
        }
      },
      {
        title: '模版类型',
        name: 'type',
        dict: [
          { code: 0, codeName: '普通问卷' },
          { code: 1, codeName: '随堂问卷' },
          { code: 2, codeName: '回执问卷' },
          { code: 3, codeName: '满意度问卷' }
        ],
        formItem: {
          rules: [{
            required: true,
            message: '请选择问卷类型',
          }],
          initialValue: this.initialValue.type,
          type: 'select'
        }
      },
      {
        title: "模版状态",
        name: "status",
        dataIndex: "status",
        tableItem: {},
        dict: [
          {code: 1, codeName: '打开'},
          {code: 0, codeName: '关闭'}
        ],
        formItem: {
          initialValue: this.initialValue.status,
          type: 'radio',
        }
      },
      {
        title: '上传封面',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <>
                {getFieldDecorator('questionImg', {
                  initialValue: (this.initialValue && this.initialValue.img) ? [
                    {fileId:this.initialValue.img}
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={1.93}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过1MB!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        }
      },
      {
        title: '问卷说明',
        name: 'intro',
        dataIndex: 'intro',
        formItem: {
          type: 'textarea',
          placeholder: '介绍最多输入300个字符',
          maxLength: 300,
          initialValue: this.initialValue.intro
        },
      }
    ]

    let onSubmit = this._saveSurveyTemplate.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: this.formFooter(),
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 15}
      }
    }

    const wizCustomStepsProps = {
      header: steps,
      current: this.state.current,
      content: this.stepView(formProps),
      footer: null
    }

    return (
      <WizSpin tip={'加载中'} spinning={surveyTemplateLoading}>
        <WizCustomSteps {...wizCustomStepsProps} />
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {surveyTemplate} = state;
  const addSurveyTemplate = modelUtils.getModelEntity(surveyTemplate, 'addSurveyTemplate');
  const load = modelUtils.getLoadingState(state, ['surveyTemplate']);
  return {
    addSurveyTemplate: addSurveyTemplate,
    ...load
  }
};

export default connect(mapStateToProps)(SurveyTemplateDetail);
